interface City {
  id: number;
  nome: string;
}

export default async function citiesService(UF: string): Promise<City[]> {
  return fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF}/distritos`)
    .then(res => res.json())
}
